import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../sharedModules/utils/axios.utils';
import { collectionCandidatesQueryKey } from './useCollectionClients';

export type ContactEmailAction = 'add' | 'remove';

interface ToggleContactEmailArgs {
  id: number;
  con_id_no: string;
  action: ContactEmailAction;
  location: string;
}

const toggleContactEmail = async ({ id, con_id_no, action }: ToggleContactEmailArgs) =>
  axios.patch(`/collections/clients/${id}/emails`, { contact: { con_id_no, action } });

export const useToggleCollectionClientContactEmail = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: toggleContactEmail,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: [`/collections/clients/${variables.id}`, undefined] });
      void queryClient.invalidateQueries({ queryKey: collectionCandidatesQueryKey(variables.location) });
    },
  });

  return {
    toggleContactEmail: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
};
